<div class="dialog-header-box">주소 찾기</div>

<section class="daum-postcode-dialog-box">
  <div class="daum-postcode-box"></div>
</section>
